import { PaperProps, Paper } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { createContext, useContext } from 'react';

type DeckContextData = {
  direction: 'vertical' | 'horizontal';
};

export const DeckContext = createContext<DeckContextData | null>(null);
export const useDeckContext = () => useContext(DeckContext);

export type StackableCardDeckProps = PaperProps & {
  /**
   * Optional classes
   */
  className?: string;

  /**
   * The direction of the stack
   */
  direction?: 'horizontal' | 'vertical';
};

export const StackableCardDeck: React.FC<StackableCardDeckProps> = ({ children, direction = 'vertical', elevation = 1, ...props }) => {
  const { classes, cx } = useStyles();

  return (
    <Paper
      {...props}
      elevation={elevation}
      className={cx(
        classes.deck,
        direction === 'vertical' ? classes.vertical : classes.horizontal,
        props.className
      )}
    >
      <DeckContext.Provider value={{ direction }}>
        {children}
      </DeckContext.Provider>
    </Paper>
  );
};

const useStyles = makeStyles({ name: 'StackableCardDeck' })((theme) => ({
  deck: {
    borderRadius: 0,
    boxShadow: 'none',
    display: 'flex',
    overflow: 'hidden',
    width: '100%',
    '& .MuiCard-root': {
      borderRadius: 0,
      boxShadow: 'none',
      flex: 1
    },
    [theme.breakpoints.up('sm')]: {
      borderRadius: '4px',
      boxShadow: theme.shadows[1],
    }
  },
  horizontal: {
    flexDirection: 'row',
  },
  vertical: {
    flexDirection: 'column',
    '& .MuiCard-root': {
      borderBottom: `1px solid ${theme.palette.divider}`,
      '&:first-child': {
        borderTop: `1px solid ${theme.palette.divider}`,
      },
      '&:not(:last-child)': {
        [theme.breakpoints.up('sm')]: {
          border: 0,
          borderBottom: `1px solid ${theme.palette.divider}`,
        }
      }
    }
  },
}));
